var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineCOnsultationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 9,
    fill: "url(#paint0_linear_11449_46865)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1662 25.1331C26.8914 23.8534 28.016 21.8083 28.016 19.5006V12.7506C28.016 12.2332 27.5966 11.8131 27.08 11.8131H24.1512C23.9611 10.2331 22.6291 9 20.9995 9C19.3698 9 18.0378 10.2331 17.8477 11.8126H14.919C14.4024 11.8126 13.9829 12.2327 13.9829 12.7501V19.5C13.9829 21.8077 15.1075 23.8534 16.8328 25.1325C14.0126 26.1977 12 28.8983 12 32.0625C12 32.5799 12.4194 33 12.936 33H29.064C29.5806 33 30 32.5799 30 32.0625C30 28.8989 27.9874 26.1982 25.1667 25.1331H25.1662ZM20.9995 10.8746C21.7266 10.8746 22.3173 11.4648 22.3173 12.1904C22.3173 12.9156 21.7266 13.5062 20.9995 13.5062C20.2724 13.5062 19.6816 12.9161 19.6816 12.1904C19.6816 11.4653 20.2724 10.8746 20.9995 10.8746ZM18.1996 13.6872C18.7382 14.6902 19.784 15.3817 20.9995 15.3817C22.215 15.3817 23.2607 14.6901 23.7993 13.6872H26.1441V16.7436H15.855V13.6872H18.1996ZM15.8549 19.5002V18.6181H26.1439V19.5002C26.1439 22.3352 23.8362 24.6414 20.9993 24.6414C18.163 24.6414 15.8547 22.3352 15.8547 19.5002H15.8549ZM13.952 31.1256C14.4044 28.5123 16.7147 26.517 19.4883 26.517H22.511C25.2841 26.517 27.594 28.5119 28.0473 31.1256H13.952Z",
    fill: "#EE960D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11449_46865",
    x1: 7,
    y1: 6.5,
    x2: 85.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5DE",
    stopOpacity: 0.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineCOnsultationIcon);
export default __webpack_public_path__ + "static/media/OfflineCOnsultationIcon.21318fa230a83a2b8a880aedc9d8f4dc.svg";
export { ForwardRef as ReactComponent };